import edap, {GENERIC_EVENT} from '../../utils/edap';
import {CATEGORY, getBoardIdListingId} from '../edap';

// generic events
export const generic = {
    TRIP_BOARDS_RECOMMENDED_PROPERTY_VIEW: 'board.recommended.property.view',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_LISTING_CLICK: 'board.recommended.property.click',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_NEXT_CLICK: 'board.recommended.property.next.click',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_PREV_CLICK: 'board.recommended.property.prev.click',
    TRIP_BOARDS_RECOMMENDED_PROPERTY_RECOMMENDED: 'board.recommended.property.recommended'
};

 // events
export const propertyViewed = (boardId, listingId, position, total) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_VIEW,
        eventlabel: `${edap.getPositionLabel(position, total)};${getBoardIdListingId(boardId, listingId)}`,
        highfrequency: 'true'
    });
};

export const propertiesRecommended = (boardId, total) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_RECOMMENDED,
        eventlabel: `${getBoardIdListingId(boardId)};total=${total}`
    });
};

export const recommendedListingClick = (boardId, listingId, position, total) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_LISTING_CLICK,
        eventlabel: `${edap.getPositionLabel(position, total)};${getBoardIdListingId(boardId, listingId)}`
    }, {delayProcessing: true});
};

export const carouselNext = (boardId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_NEXT_CLICK,
        eventlabel: `${getBoardIdListingId(boardId)}`,
        highfrequency: 'true'
    });
};

export const carouselPrev = (boardId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_RECOMMENDED_PROPERTY_PREV_CLICK,
        eventlabel: `${getBoardIdListingId(boardId)}`,
        highfrequency: 'true'
    });
};





// WEBPACK FOOTER //
// ./src/universal/tripboard/recommended-properties/edap.js